import VavatoTheme from './VavatoTheme'

export const fontSizes = {
  bodyLarge: '1.125rem',
  body: '1rem',
  bodySmall: '0.92rem',
  small: '0.85rem',
  h1: '3rem',
  h2: '1.75rem',
  h3: '1.6rem',
  h4: '1.375rem',
  h5: '1.125rem',
  h6: '1rem'
}

export const fontWeights = {
  bold: '600',
  semiBold: '500',
  regular: '400'
}

export const colors = {
  primary: VavatoTheme.primary,
  secondary: VavatoTheme.secondary,
  success: VavatoTheme.success,
  error: VavatoTheme.error,
  info: VavatoTheme.info
}
